export default {
  name: 'ServiceMailMagazineItem',
  props: {
    model: Object,
    index: Number
  },
  computed: {
    mailMagazineName () {
      return this.model.mailMagazineName
    },
    mailMagazineId () {
      return this.model.serviceMailMagazineId
    },
    mailAddress () {
      return this.model.mailMagazineAddress
    },
    deliveryTypeMstName () {
      return this.model.deliveryTypeName
    },
    noticeTypeMstName () {
      return this.model.noticeTypeName
    },
    keyword () {
      if (!this.model.keywords ||
        !this.model.keywords.length)
        return ''
      return this.model.keywords.join('、')
    },
    ignoreKeyword () {
      if (!this.model.exclusiveKeywords ||
        !this.model.exclusiveKeywords.length)
        return ''
      return this.model.exclusiveKeywords.join('、')
    }
  },
  methods: {
    deliveryItem () {
      this.$emit('childs-event-delivery', {
        id: this.model.serviceMailMagazineUuid
      })
    },
    modifyItem () {
      this.$emit('childs-event-modify', {
        id: this.model.serviceMailMagazineUuid
      })
    },
    deleteItem () {
      this.$emit('childs-event-delete', {
        id: this.model.serviceMailMagazineUuid
      })
    }
  }
}